// src/pages/Terms.jsx
import React from "react";

export default function Terms() {
  return (
    <main className="min-h-screen bg-[#F7F4EA] px-4 py-8 text-[#1E2A38]">
      <div className="mx-auto max-w-3xl rounded-2xl bg-white p-6 shadow-md md:p-10">
        <h1 className="mb-2 text-3xl font-bold">TeamKitty Terms of Use</h1>

        <p className="mb-6 text-sm text-slate-500">
          <strong>Effective Date:</strong> {new Date().toISOString().slice(0, 10)}
        </p>

        <p className="mb-4">
          These Terms govern your access to and use of the TeamKitty platform
          (“Service”). By using TeamKitty, you agree to be bound by these Terms.
        </p>

        <h2 className="mt-6 mb-2 text-xl font-semibold">1. About TeamKitty</h2>
        <p className="mb-4">
          TeamKitty is a technology platform designed to help teams, clubs and
          social groups track shared balances, top-ups, purchases, fines and
          related team activity.
        </p>
        <p className="mb-4">
          <strong>
            TeamKitty does not sell, supply, distribute, deliver, or facilitate
            the sale of alcohol or any other regulated goods.
          </strong>
        </p>

        <h2 className="mt-6 mb-2 text-xl font-semibold">2. Age Requirement</h2>
        <p className="mb-4">
          You must be 18 years or older to use any alcohol-related or adult
          social activity features of the Service. By registering, you confirm
          that you meet this requirement.
        </p>

        <h2 className="mt-6 mb-2 text-xl font-semibold">3. Payments and Balances</h2>
        <p className="mb-4">
          Funds added to TeamKitty are used for internal balance tracking within
          a team or group. They do not represent payment to TeamKitty for the
          purchase of alcohol, food, merchandise or any other goods.
        </p>
        <p className="mb-4">
          TeamKitty may use third-party payment providers to process top-ups,
          but TeamKitty does not take ownership of, supply, or accept
          responsibility for any goods or services purchased independently by a
          club, team, venue, supplier or user.
        </p>

        <h2 className="mt-6 mb-2 text-xl font-semibold">4. User and Club Responsibility</h2>
        <p className="mb-4">
          Users, teams and clubs are responsible for their own conduct, records,
          purchases, compliance obligations and use of the Service. This includes
          compliance with applicable laws, venue rules, alcohol licensing
          requirements and responsible service obligations.
        </p>

        <h2 className="mt-6 mb-2 text-xl font-semibold">5. Third Parties</h2>
        <p className="mb-4">
          Any interaction with clubs, teams, venues, suppliers, payment providers
          or other third parties is between you and those parties. TeamKitty is
          not responsible for their conduct, compliance, pricing, fulfilment or
          service delivery.
        </p>

        <h2 className="mt-6 mb-2 text-xl font-semibold">6. Acceptable Use</h2>
        <p className="mb-4">
          You agree not to misuse the platform, interfere with its operation,
          enter false or misleading information, or use it in a way that breaches
          any applicable law or regulation. TeamKitty may suspend or terminate
          access where misuse is suspected.
        </p>

        <h2 className="mt-6 mb-2 text-xl font-semibold">7. Disclaimer</h2>
        <p className="mb-4">
          TeamKitty is provided “as is” without warranties of any kind. To the
          maximum extent permitted by law, TeamKitty disclaims liability for loss,
          damage, injury or harm arising from:
        </p>
        <ul className="mb-4 ml-6 list-disc">
          <li>actions or omissions of users, clubs, venues or third parties</li>
          <li>misuse of the platform</li>
          <li>incorrect records entered by users or administrators</li>
          <li>consumption of alcohol or participation in social activities</li>
          <li>any breach of applicable laws or regulations</li>
        </ul>

        <h2 className="mt-6 mb-2 text-xl font-semibold">8. Indemnity</h2>
        <p className="mb-4">
          You agree to indemnify and hold harmless TeamKitty, its owners,
          operators and affiliates from claims, liabilities, damages or expenses
          arising from your use of the Service, your conduct, or your breach of
          these Terms.
        </p>

        <h2 className="mt-6 mb-2 text-xl font-semibold">9. Privacy</h2>
        <p className="mb-4">
          We collect and use information required to operate the Service, manage
          accounts, process payments and support team administration. A separate
          Privacy Policy may be published and updated from time to time.
        </p>

        <h2 className="mt-6 mb-2 text-xl font-semibold">10. Changes to Terms</h2>
        <p className="mb-4">
          We may update these Terms from time to time. Continued use of the
          Service indicates acceptance of any updated Terms.
        </p>

        <h2 className="mt-6 mb-2 text-xl font-semibold">11. Responsible Use</h2>
        <p className="mb-4">
          Where teams use TeamKitty to track social or alcohol-related activity,
          all users should act responsibly and comply with local laws and venue
          rules. For responsible drinking information, visit{" "}
          <a
            href="https://www.drinkwise.org.au"
            target="_blank"
            rel="noopener noreferrer"
            className="font-semibold text-[#0F766E] underline"
          >
            DrinkWise
          </a>
          .
        </p>

        <p className="mt-8 text-sm text-slate-500">
          Contact:{" "}
          <a href="mailto:contact@teamkitty.io" className="text-[#0F766E] underline">
            contact@teamkitty.io
          </a>
        </p>
      </div>
    </main>
  );
}
